module.exports = __webpack_public_path__ + "static/media/Jangmo-o_gaussian2.a1e37385.png";